import { ListItem, SidebarModal } from '@domain-group/suit-theme'

import type { UseArtworkPayload } from '@hooks/useArtwork'

interface PagesProps {
  artworkPayload: UseArtworkPayload,
}

const Pages = (props: PagesProps) => {
  const {
    artworkPayload: {
      filteredArtworkPages,
    },
  } = props

  const pageCount = filteredArtworkPages.length

  return (
    <SidebarModal.ExpandableSection
      label="Pages"
      title={`${pageCount} ${pageCount === 1 ? 'Page' : 'Pages'}`}
      style={{ marginTop: 16 }}
    >
      {filteredArtworkPages.map(artworkPage => (
        // @ts-expect-error TS2339
        <ListItem.Compact
          boxProps={{ paddingX: 0 }}
          contentRight={`Template #${artworkPage.template_page_id}`}
          key={artworkPage.id}
          showAngleIcon={false}
        >
          Page #{artworkPage.id}
          {/*
         // @ts-expect-error TS2339 */}
        </ListItem.Compact>
      ))}
    </SidebarModal.ExpandableSection>
  )
}

export default Pages
